import { pickBy } from 'lodash';
import { Iterable, Set } from 'immutable';

import { CDN_PATH } from '../../constants/common';
import { getUrlParams } from '../../utils/uriUtils';

export const FLEX_DATES_PARAM = 'flex_dates';

// TODO: в апи
export const hasNewResults = (oldStatus, newStatus) => {
  const getSuccessfulCount = (status) =>
    status.filter((s) => ['completed', 'cached'].indexOf(s) !== -1).size;
  return getSuccessfulCount(oldStatus) !== getSuccessfulCount(newStatus);
};
export const isSearchRequestDone = (status) =>
  status.length === 0
    ? false
    : status.every((st) => ['pending', 'performing'].indexOf(st) === -1);
export const getDonePercent = (status) =>
  (status.filter((st) => ['pending', 'performing'].indexOf(st) === -1).size /
    status.size) *
  100;

const statusWeight = {
  completed: 1000,
  cached: 900,
  waiting: 800,
  warming: 700,
  loading: 600,
  pending: 500,
  performing: 400,
  all_filtered: 350,
  no_results: 300,
  timed_out: 250,
  skipped: 200,
  failed: 100,
};

export const sortFunction = (st1, st2) => statusWeight[st2] - statusWeight[st1];

export const getFiltersFromUrl = () =>
  pickBy(getUrlParams(), (value, paramName) => paramName.startsWith('filter_'));

// IMMUTABLE UTILS
export const safeToJS = (data) =>
  (Iterable.isIterable(data) && data.toJS()) || data;
export const keyIn = (...keys) => {
  const keySet = Set(keys);
  return (v, k) => keySet.has(k);
};

/**
 * Хак, пока нет роутера для обработки нажатия назад на мобильной версии
 */
export const pushDummyHistoryState = () => {
  window.history.pushState(null, document.title, document.location.href);
};

export const prepareImages = (images) =>
  images.map((image) => ({
    x245x240: `${CDN_PATH}${image.x245x240}`,
    x500: `${CDN_PATH}${image.x500}`,
  }));

// returns date for cheapest package
export const getCheapestDate = (dates) =>
  dates &&
  Object.keys(dates).reduce((cheapest, current) =>
    dates[cheapest] > dates[current] ? current : cheapest,
  );

/**
 * Returns extra params to show hotel page accouding to selected offer
 *
 * @typedef PackageInfo
 * @property {Array} dates
 * @property {number} price
 * @property {number} min_price_nights
 * @typedef Filters
 * @property {string} operators
 * @property {boolean} instantConfirm
 * @param {PackageInfo} packageInfo
 * @param {Filters} filters
 * @returns
 */

export const getHotelExtraParams = (packageInfo, filters) => {
  const { dates, min_price_nights } = packageInfo;
  const {
    operators,
    instantConfirm,
    ltExtras,
    freeCancel,
    meals,
    paymentBenefits,
  } = filters || {};
  const date = getCheapestDate(dates);
  const price = dates && dates[date];
  return {
    offer_price: price,
    offer_nights: min_price_nights,
    offer_date: date,
    offer_operators: operators,
    offer_instant_confirm: instantConfirm,
    offer_lt_extras: ltExtras,
    offer_free_cancel: freeCancel,
    offer_meals: meals,
    offer_labels: [paymentBenefits].join(),
  };
};

/**
 * ccx-uuid
 */
export const getCCXUUID = () => {
  const data = localStorage.getItem('ccx-uuid') || '';

  return encodeURI(data);
};

export const getSuggestedTour = (adjacent_tour) => ({
  price: adjacent_tour.price,
  availability: {
    hotel: adjacent_tour.accommodation_availability,
    flight: adjacent_tour.flight_seats,
  },
  nightsCount: adjacent_tour.duration,
  departureDate: adjacent_tour.start_date,
  instantConfirm: adjacent_tour.instant_confirm,
});
